import {IconSizeColorProps} from "./types";

export default function CheckboxIcon({
    size=16,
    color="#E3E3E3",
    ...props
}:IconSizeColorProps) {
    return <svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="2.08203" y="2.58325" width="11.8333" height="11.8333" rx="3.25" stroke={color} strokeWidth="1.5"/>
    </svg>

}